import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

function RestoreScreen() {

  const navigate = useNavigate()

  const [loadingInfo, setLoadingInfo] =
    useState(true)

  const [restoring, setRestoring] =
    useState(false)

  const [daysLeft, setDaysLeft] =
    useState(null)

  const [error, setError] =
    useState('')

  // =====================================================
  // TOKEN
  // =====================================================

  const token =
    localStorage.getItem('token') ||
    localStorage.getItem('login_token')

  // =====================================================
  // LOAD RESTORE INFO
  // =====================================================

  useEffect(() => {
    loadRestoreInfo()
  }, [])

  const loadRestoreInfo = async () => {

    try {

      const res = await fetch(
        'https://khata.moxpal.com/api/v2/index.php?path=khata/restore-info',
        {
          headers: {
            Authorization:
              `Bearer ${token}`,
          },
        }
      )

      const json =
        await res.json()

      if (json.success) {

        setDaysLeft(
          json.days_left
        )

      } else {

        setError(
          json.message ||
          'No restore data found.'
        )

      }

    } catch (e) {

      setError(
        'Failed to check restore status.'
      )

    }

    setLoadingInfo(false)
  }

  // =====================================================
  // RESTORE
  // =====================================================

  const restoreKhata =
    async () => {

      try {

        setRestoring(true)

        const res = await fetch(
          'https://khata.moxpal.com/api/v2/index.php?path=khata/restore',
          {
            method: 'POST',

            headers: {
              Authorization:
                `Bearer ${token}`,
              'Content-Type':
                'application/json',
            },
          }
        )

        const json =
          await res.json()

        if (json.success) {

          navigate(
            '/dashboard',
            { replace: true }
          )

        } else {

          alert(
            json?.error?.message ||
            'Could not restore data.'
          )

        }

      } catch (e) {

        alert(
          'Restore failed.'
        )

      }

      setRestoring(false)
    }

  // =====================================================
  // UI
  // =====================================================

  return (
    <div style={styles.page}>

      <div style={styles.card}>

        {
          loadingInfo ? (

            <div style={styles.center}>
              Loading...
            </div>

          ) : error ? (

            <div style={styles.error}>
              {error}
            </div>

          ) : (

            <>
              <div style={styles.icon}>
                ♻️
              </div>

              <div style={styles.title}>
                Restore Your Khata
              </div>

              <div style={styles.sub}>
                We found your deleted khata.
                <br />
                You can restore it within{' '}
                <b>{daysLeft} days</b>.
              </div>

              <div style={styles.warning}>
                ⚠️ If you do not restore your
                khata within {daysLeft} days,
                your data will be permanently
                deleted.
              </div>

              <button
                style={styles.button}
                onClick={restoreKhata}
                disabled={restoring}
              >
                {
                  restoring
                    ? 'Restoring...'
                    : 'Restore My Khata'
                }
              </button>
            </>
          )
        }

      </div>
    </div>
  )
}

const styles = {

  page: {
    minHeight: '100vh',
    background: '#F4F6FB',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    padding: '20px',
  },

  card: {
    width: '100%',
    maxWidth: '460px',

    background: '#fff',

    borderRadius: '24px',

    padding: '34px',

    boxShadow:
      '0 20px 50px rgba(0,0,0,0.08)',
  },

  center: {
    textAlign: 'center',
    fontSize: '15px',
  },

  error: {
    textAlign: 'center',
    color: '#DC2626',
    fontSize: '14px',
  },

  icon: {
    fontSize: '60px',
    textAlign: 'center',
  },

  title: {
    marginTop: '20px',

    textAlign: 'center',

    fontSize: '28px',

    fontWeight: '700',

    color: '#111827',
  },

  sub: {
    marginTop: '14px',

    textAlign: 'center',

    lineHeight: '26px',

    fontSize: '15px',

    color: '#6B7280',
  },

  warning: {
    marginTop: '24px',

    background: '#FFF7ED',

    border:
      '1px solid #FDBA74',

    color: '#9A3412',

    borderRadius: '16px',

    padding: '16px',

    fontSize: '14px',

    lineHeight: '24px',
  },

  button: {
    width: '100%',

    height: '54px',

    marginTop: '30px',

    border: 'none',

    borderRadius: '16px',

    background: '#16A34A',

    color: '#fff',

    fontSize: '16px',

    fontWeight: '700',

    cursor: 'pointer',
  },
}

export default RestoreScreen